import request from 'tools/request'

export const getMyCarrierList = async () => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers`,
    {
      params: {
        status: 'ONBOARDED',
        'carrierName:fuzzy': '',
        includeConfidentialEvents: true,
      },
    }
  )
    return res?.data
}

export const getInvitedCarrierList = async () => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL}carriers`,
    {
      params: {
        status: 'INVITED, EXPIRED, VERIFICATION_FAILED, REINVITED',
      },
    }
  )
  return res?.data
}

/**
 * carrierName:fuzzy:
 *
 * others
 * codeType (DOT, MC, UUID, SCAC)
 * codeValue (val)
 */
export const getCarrierSearchList = async (params: any) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/search`,
    {
      params: params,
    }
  )
  return res?.data
}

/**
 *
 * @param payLoad {"carrierInfo":{"carrierName":"ABC CARRIER"},"contactInfo":{"email":"sadam@r1vs.com","firstName":"ss","lastName":"s", "safetyContactEmail":"mail@r1vs.com"}}
 * @param codeType DOT
 * @param codeValue 9292
 * @returns
 */
export const inviteCarrier = async (
  payLoad: any,
  codeType: string,
  codeValue: string
) => {
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/invite?codeType=${codeType}&codeValue=${codeValue}`,
    payLoad
  )
  return res?.data
}

export const inviteCarrierToReconnect = async (
  payLoad: any,
  codeType: string,
  codeValue: string,
  eldProvider: string,
) => {
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/invite-reconnect?codeType=${codeType}&codeValue=${codeValue}&eldVendor=${eldProvider}`,
    payLoad
  )
  return res?.data
}

export const getAgentMyCarrierList = async () => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/assigned/agent`,
    {
      params: {
        includeConfidentialEvents: true,
      },
    }
  )
  return res?.data
}

export const editCarrier = async (payLoad: any, codeType: string, codeValue: string) => {
  const res = await request.put(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers?codeType=${codeType}&codeValue=${codeValue}`, 
    payLoad
  )
  return res?.data
}

export const offboardCarrier = async (carrierId: string, eldVendor: string) => {
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/offboard?codeType=TCID&codeValue=${carrierId}&eldVendor=${eldVendor}`
  )
  return res?.data
}

export const changeCarrierStatus = async (payload: any) => {
  const res = await request.put(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/change-status`,
    payload
  )
  return res?.data
}

export const getActiveUnitsWithCameras = async (carrierId: string) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/vehicles/active-camera-count?carrierId=${carrierId}`
  )
  return res?.data
}